import React, { useState, useEffect } from "react";
import Form from "./Form";
import authHeader from "../services/AuthHeader";
import axios from 'axios';
import AuthService from '../services/AuthService';
import { useHistory } from 'react-router-dom';

const Ballot = (props) => {
  const [user,] = useState([]);
  const [showBallot,setShowBallot] = useState(false);
  let history = useHistory();
  const reloadPage = AuthService.reloadPage();
  const electionTitle = props.ballotData && props.ballotData.electionName
    ? props.ballotData.electionName
    : 'Election Ballot';
  const showMockUserReturnButton = AuthService.isAdmin() && props.ballotData && props.ballotData.locked;
  if(typeof props.studentInfo.allColleges === 'undefined'){
    history.push(reloadPage);
    window.location.reload();
  }

  /* check if mocked student has voted  */
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_BASE + 'voted/'+ props.studentInfo.starId,{ headers: authHeader() }
      )
      .then((res) => {
        if (res.data) {
            setShowBallot(false);
            history.push("/mock");
        } else {
            setShowBallot(true);
        }
      });
  }, []);

  const ShowStudent = ()=> {
    if(props.studentInfo) {
        return (
          <>
              <div className='box-voter text-center'>
                  <h2 className='h3'>Voter Info</h2>
                  <div>{props.studentInfo.first_Name} {props.studentInfo.last_Name}</div>
                  <div>{props.studentInfo.residential === 'O'? 'Off-Campus':'On-Campus'} Resident</div>
                  <div>{props.studentInfo.classLevel==='U'? 'Undergraduate':"Graduate"}</div>
                  <div>{props.studentInfo.allColleges.map(function(item, index) {                  
                      return (item['collegeDescription'] !== '') ? ((index < (props.studentInfo.allColleges.length -1)) ? item['collegeDescription']+', ' : item['collegeDescription']) : '';
                    })}</div> 
              </div>
              <br />
          </>
        )
    } else {
        return (<div>Pick a student to mock</div>)
    }
}

return  (showBallot ? (
    <>
      <h1>{electionTitle}</h1>
      <ShowStudent />
      <Form
        ballotData={props.ballotData}
        showElectionHeading={false}
        user={user}
        studentInfo={props.studentInfo}
        votes={props.votes}
        setVotes={props.setVotes}
        submitButtonLabel={showMockUserReturnButton ? 'Back to Mock User' : 'Submit'}
        submitButtonType={showMockUserReturnButton ? 'button' : 'submit'}
        onSubmitButtonClick={
          showMockUserReturnButton ? () => history.push('/mock') : undefined
        }
      />
    </>) : (
        <div role='status' aria-live='polite'>Loading...</div>
    )
  ); 
}

export default Ballot;
